import axios from 'axios';

const getters = {
  firstName: (state) => state.first_name,
  lastName: (state) => state.last_name,
  invalidOfferCode: (state) => state.invalidOfferCode,
  loggedIn: (state) => state.loggedIn,
  offerCode: (state) => state.offerCode,
  ssnMatch: (state) => state.ssnMatch,
  dobMatch: (state) => state.dobMatch,
  applyCard: (state) => state.applyCard,
  accountCreationErrorMessage: (state) => state.accountCreationErrorMessage
};

export const mutations = {
  ADD_OFFER_CODE(state, code) {
    state.offerCode = code;
  },
  ADD_CUSTOMER_INFO(state, customerOffer) {
    state.first_name = customerOffer.first_name
    state.last_name = customerOffer.last_name
    state.applicationData.home_address = customerOffer.address
    state.applicationData.postal_code = customerOffer.first_5_digits_of_zipcode
    state.applicationData.city = customerOffer.city
    state.applicationData.state = customerOffer.state
  },
  INVALID_OFFER_CODE(state, bool) {
    state.invalidOfferCode = bool;
  },
  LOGGED_IN(state, bool) {
    state.loggedIn = bool;
  },
  SSN_MATCH(state, bool) {
    state.ssnMatch = bool;
  },
  DOB_MATCH(state, bool) {
    state.dobMatch = bool;
  },
  ACCOUNT_CREATION_ERROR(state, error) {
    state.accountCreationErrorMessage = error;
  },
  ADD_VERIFICATION_PAGE_DATA(state, formData) {
    state.applicationData.suffix = formData['suffix'];
    state.applicationData.social_security_number = formData['ssn'];
    state.applicationData.date_of_birth = formData['dob']
  },
  ADD_APPLICATION_DATA(state, formData) {
    state.applicationData.amount = formData['amount'];
    state.applicationData.home_address = formData['home_address'];
    state.applicationData.apt_or_unit = formData['apt_or_unit'];
    state.applicationData.postal_code = formData['postal_code'];
    state.applicationData.city = formData['city'];
    state.applicationData.state = formData['state'];
    state.applicationData.main_phone = formData['main_phone'];
    state.applicationData.rent_or_own = formData['rent_or_own'];
  },
  ADD_ACCOUNT_LOGIN_DATA(state, formData) {
    state.applicationData.email = formData['email'];
    state.applicationData.password = formData['password'];
  },
  SET_APPLY_CARD(state, card) {
    state.applyCard = card;
  }
};

const state = {
  applicationData: {
    amount:'',
    suffix: '',
    social_security_number: '',
    date_of_birth: '',
    home_address: '',
    apt_or_unit: '',
    postal_code: '',
    city: '',
    state: '',
    main_phone: '',
    rent_or_own: '',
    email: '',
    password: '',
  },
  first_name: '',
  last_name: '',
  offerCode: '',
  invalidOfferCode: false,
  loggedIn: false,
  ssnMatch: false,
  dobMatch: false,
  applyCard: 'address-amount-card',
  accountCreationErrorMessage: '',
};

export const actions = {
  async addOfferCode(context, code) {
    await context.commit('ADD_OFFER_CODE', code.replace(/-/g, ''));
  },

  async resetOfferCodeError(context) {
    await context.commit('INVALID_OFFER_CODE', false);
  },

  async fetchCustomerOfferAndAddToState(context) {
    const token = document.querySelector('meta[name="csrf-token"]') || {
      content: 'no-csrf-token',
    };
    const railsAxios = axios.create({
      headers: {
        common: {
          'X-CSRF-Token': token.content,
        },
      },
    });

    try {
      const { data } = await railsAxios.post(
        '/offers/customer_offer',
        { offer_code: context.state.offerCode },
        { 'Content-Type': 'application/json' }
      );

      if(data.logged_in) {
        await context.commit('LOGGED_IN', true);
      }

      if (data.first_name && data.last_name) {
        await context.commit('ADD_CUSTOMER_INFO', data);
        await context.commit('INVALID_OFFER_CODE', false);
      } else {
        await context.commit('INVALID_OFFER_CODE', true);
      }

    } catch (error) {
      console.error(error);
    }
  },

  async verifyOffer(context, payload) {
    const token = document.querySelector('meta[name="csrf-token"]') || {
      content: 'no-csrf-token',
    };
    const railsAxios = axios.create({
      headers: {
        common: {
          'X-CSRF-Token': token.content,
        },
      },
    });

    try {
      const { data } = await railsAxios.post(
        '/offers/verify_offer',
        {
          social_security_number: payload.ssn.replace(/-/g, ''),
          date_of_birth: payload.dob.replace(/(..)-(..)-(....)/, '$3-$1-$2'),
          offer_code: context.state.offerCode
        },
        { 'Content-Type': 'application/json' }
      );
      await context.commit( 'DOB_MATCH', data.dob_match );
      await context.commit( 'SSN_MATCH', data.ssn_match );
    } catch (error) {
      console.error(error);
    }
  },

  async createAccount(context) {
    const token = document.querySelector('meta[name="csrf-token"]') || {
      content: 'no-csrf-token',
    };
    const railsAxios = axios.create({
      headers: {
        common: {
          'X-CSRF-Token': token.content,
        },
      },
    });

    try {
      await context.commit( 'ACCOUNT_CREATION_ERROR', '');
      const { data } = await railsAxios.post(
        '/offers/create_account',
        {
          email: context.state.applicationData.email,
          first_name: context.state.first_name,
          last_name: context.state.last_name,
          suffix: context.state.applicationData.suffix,
          home_address: context.state.applicationData.home_address,
          apt_or_unit: context.state.applicationData.apt_or_unit,
          city: context.state.applicationData.city,
          state: context.state.applicationData.state,
          postal_code: context.state.applicationData.postal_code,
          main_phone: context.state.applicationData.
            main_phone.replace(/-/g, ''),
          rent_or_own: context.state.applicationData.rent_or_own,
          password: context.state.applicationData.password,
          social_security_number: context.state.applicationData.
            social_security_number.replace(/-/g, ''),
          date_of_birth: context.state.applicationData.
            date_of_birth.replace(/(..)-(..)-(....)/, '$3-$1-$2'),
          offer_code: context.state.offerCode,
          amount: context.state.applicationData.
            amount.replace(/\$/g, '').replace(/,/g, '')
        },
        { 'Content-Type': 'application/json' }
      );
      if (data.error) {
        await context.commit( 'ACCOUNT_CREATION_ERROR', data.error);
      }
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  getters,
  state,
  actions,
  mutations,
};
